import api from './api';
import type { InstagramTokenStatus, InstagramAuthResponse, InstagramPost } from '@app-types/models/instagram';
import type { Showcase } from '@app-types/models/showcase';

interface InstagramSyncResponse {
  success: boolean;
  data: {
    showcases: Showcase[];
    syncedCount: number;
  };
}

interface InstagramSyncBody {
  stylistId: string;
  postIds: string[];
  serviceTypeIds?: string[];
}

export const checkInstagramTokenStatus = async (stylistId: string): Promise<InstagramTokenStatus> => {
  const response = await api.get<InstagramTokenStatus>(`/business/instagram/token-status/${stylistId}`);
  return response.data;
};

export const initiateInstagramAuth = async (stylistId: string, frontendUrl: string): Promise<InstagramAuthResponse> => {
  const response = await api.post<InstagramAuthResponse>('/business/instagram/auth', { stylistId, frontendUrl });
  if (response.data.authUrl) {
    return response.data;
  } else {
    throw new Error('No auth URL received');
  }
};

export const syncInstagramPosts = async (stylistId: string, postIds: string[], serviceTypeId?: string): Promise<InstagramSyncResponse> => {
  const body: InstagramSyncBody = { stylistId, postIds };
  if (serviceTypeId) {
    body.serviceTypeIds = [serviceTypeId];
  }
  const response = await api.post<InstagramSyncResponse>('/business/instagram/sync', body);
  return response.data;
};

interface InstagramPostsResponse {
  success: boolean;
  data: InstagramPost[];
  message?: string;
}

export const getInstagramPosts = async (stylistId: string): Promise<InstagramPostsResponse> => {
  const response = await api.get<InstagramPostsResponse>(`/business/instagram/posts/${stylistId}`);
  return response.data;
};

export const disconnectInstagram = async (stylistId: string): Promise<unknown> => {
  const response = await api.delete<unknown>(`/business/instagram/disconnect/${stylistId}`);
  return response.data;
};
